// @flow
import { doLater } from "utils/domUtils";

export default (action: Function) => {
	let queueItemIdsForSet = [];
	let queueItemsForSet = {};
	let isSimulatedForSet = false;
	let queueItemsSetHandler = null;

	return (ids: string[], items: Object, simulated: ?boolean) => {
		if (!queueItemsSetHandler) {
			queueItemsSetHandler = doLater(() => {
				action({
					ids: queueItemIdsForSet,
					items: queueItemsForSet,
					simulated: isSimulatedForSet,
				});

				queueItemsForSet = {};
				queueItemIdsForSet = [];
				isSimulatedForSet = false;
				queueItemsSetHandler = null;
			}, 60);
		}

		queueItemIdsForSet = queueItemIdsForSet.concat(
			ids.filter((newId) => !~queueItemIdsForSet.indexOf(newId)),
		); // put only new ids

		queueItemsForSet = { // add/override items' data
			...queueItemsForSet,
			...items,
		};

		isSimulatedForSet = !!simulated;
	};
};
